import React from 'react';

const hasAcademyHeader = false;
export default React.createContext(hasAcademyHeader);
